<template>
  <div class="productdeta-details">
     <div class="app-down flex-between" v-if='$route.query.isApp!=1'>
      <div class="flex-center">
        <img src="../../../static/images/logo_download.svg" alt />
        <div class="download-content">
          <p>SuperEx APP</p>
          <span class="block">{{$t('300261')}}</span>
        </div>
      </div>
      <div class="flex-center">
        <dl @click="$router.push({path:'/download',query:{type:'detail'}})">
          <dt>
            <svg>
          <use xlink:href='#icon-xiazaitubiao1'></use>
         </svg>
          </dt>
          <dd>{{$t('300345')}}</dd>
        </dl>
      </div>
    </div>
    <div class="productdeta-header" v-if="$route.query.isApp!=1">
      <i
        @click="$router.go(-1)"
        class="iconfont icon-left"
        :class="{mirrorRotateLevel:isDirection}"
      ></i>
      <!-- 购买规则 -->
      <!-- <span @click="$router.push({path:'/purchaseRule',query:{isApp:$route.query.isApp,token:$route.query.token,language:$route.query.language}})">{{$t('300292')}}</span> -->
    </div>
    <div class="productdeta-main">
      <div class="swiper-banner">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(image, index) in shopMessage.imgs" :key="index">
            <img :src="image" />
          </van-swipe-item>
        </van-swipe>
        <div class="notice-bar" v-if="horseLampData.length>0">
          <van-swipe vertical class="notice-swipe" :autoplay="1500" :show-indicators="false">
            <van-swipe-item v-for="(item,index) in horseLampData" :key="index">
              <img
                :class="{mirrorRotateLevel:isDirection}"
                src="../../../static/images/congratulations.png"
                alt
              />
              <p>{{item.message}}</p>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="commodity">
        <p class="commodity-name bold">{{shopMessage.title}}</p>
        <p class="commodity-oncePrice">
          {{$t('300300')}}
          <!-- 单次参与费用 -->
          <em class="bold">&nbsp;{{shopMessage.minPrice}}</em>
          <span class="currency bold">{{shopMessage.currency.toUpperCase()}}</span>
          <span class="oldPrice">{{shopMessage.price}}{{shopMessage.currency.toUpperCase()}}</span>
        </p>
        <div class="Period">
          <span>{{$t('300338',{num:shopMessage.roundCount})}}</span>
          <span
            class="rule"
            @click="$router.push({path:'/purchaseRule',query:{token:$route.query.token,isApp:$route.query.isApp}})"
          >{{$t('300337')}}</span>
        </div>
        <div class="commodity-progress-bar">
          <div
            class="rate-of-progress"
            v-if="shopMessage.sellCount"
            :style="{width:(shopMessage.sellCount/(shopMessage.price/shopMessage.minPrice))*100+'%'}"
          >
            <div
              class="progress-img"
              :style="{width:(shopMessage.sellCount/(shopMessage.price/shopMessage.minPrice))*100+'%'}"
            ></div>
            <div class="progress-color"></div>
          </div>
          <div class="rate-of-progress" v-if="!shopMessage.sellCount">
            <div class="progress-img"></div>
            <div class="progress-color"></div>
          </div>
          <img
            class="fireImage"
            :class="{mirrorRotateLevel:isDirection}"
            src="../../../static/images/firejian.png"
            alt
          />
        </div>
        <div
          class="commodity-sellNum"
        >{{$t('300301',{num:shopMessage.sellCount,price:shopMessage.price,currency:shopMessage.currency.toUpperCase()})}}</div>
        <div
          class="announced-in-the-past"
          @click="$router.push({path:'/previous',query:{token:$route.query.token,isApp:$route.query.isApp,mallProductId:shopMessage.mallProductId}})"
          v-if="shopMessage.roundCount>1"
        >
          <span>{{$t('300335')}}</span>
          <div class="announced" v-if="prizeMsgList.length>0">
            <van-swipe vertical class="announced-swipe" :autoplay="1500" :show-indicators="false">
              <van-swipe-item v-for="(item,index) in prizeMsgList" :key="index">
                <img
                  :class="{mirrorRotateLevel:isDirection}"
                  src="../../../static/images/congratulations.png"
                  alt
                />
                <p>{{item.message}}</p>
              </van-swipe-item>
            </van-swipe>
          </div>
          <i class="iconfont icon-left" :class="{mirrorRotateLevel:!isDirection}"></i>
        </div>
        <div class="Purchase-process">
          <div class="process-top"></div>
          <div class="process-bottom"></div>
          <div class="process-content">
            <p class="bold">
              <svg>
                <use xlink:href="#icon-shangpinjieshaozuo" />
              </svg>{{$t('300339')}}
              <svg class="mirrorRotateLevel">
                <use xlink:href="#icon-shangpinjieshaozuo" />
              </svg>
              <!-- 购买流程 -->
            </p>
            <div class="flowPath">
              <dl>
                <dt>
                  <svg>
                    <use xlink:href="#icon-canyu" />
                  </svg>
                  <i class="iconfont"></i>
                </dt>
                <dd>{{$t('300294')}}</dd>
                <!-- 购买参与 -->
              </dl>
              <p :class="{mirrorRotateLevel:isDirection}">
                <svg>
                  <use xlink:href="#icon-jiantou2" />
                </svg>
              </p>
              <dl>
                <dt>
                  <svg>
                    <use xlink:href="#icon-dengdaixin" />
                  </svg>
                </dt>
                <dd>{{$t('300295')}}</dd>
                <!-- 等待结果 -->
              </dl>
              <p :class="{mirrorRotateLevel:isDirection}">
                <svg>
                  <use xlink:href="#icon-jiantou2" />
                </svg>
              </p>
              <dl>
                <dt>
                  <svg>
                    <use xlink:href="#icon-shangpinxin" />
                  </svg>
                </dt>
                <dd>{{$t('300296')}}</dd>
                <!-- 领取商品 -->
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="Product-introduction">
        <p class="bold">
          <svg>
            <use xlink:href="#icon-shangpinjieshaozuo" />
          </svg>
          {{$t('300319')}}
          <svg class="mirrorRotateLevel">
            <use xlink:href="#icon-shangpinjieshaozuo" />
          </svg>
          <!-- 商品介绍 -->
        </p>
        <div v-html="shopMessage.description"></div>
      </div>
    </div>
    <div class="productdeta-foot">
      <van-button
        class="bold"
        v-if="shopMessage.status===1&&$route.query.isApp!=1"
        @click.stop="handler()"
        type="default"
      >{{$t('300302')}}</van-button>
      <van-button
        class="bold alignBtn"
        v-if="shopMessage.status===2&&$route.query.isApp!=1"
        @click.stop="handler()"
        type="default"
      >{{$t('300303')}}</van-button>
      <div v-if="$route.query.isApp==1">
        <van-button
          class="bold"
          v-if="shopMessage.status===1"
          @click.stop="handler()"
          type="default"
        >{{$t('300302')}}</van-button>
        <van-button
          class="bold alignBtn"
          v-if="shopMessage.status===2"
          @click.stop="handler()"
          type="default"
        >{{$t('300303')}}</van-button>
        <dl @click="handleShare">
          <dt>
            <i class="iconfont icon-fenxiang"></i>
          </dt>
          <dd class="bold">{{$t('300342')}}</dd>
        </dl>
      </div>
    </div>
    <van-popup class="form-popup" :close-on-click-overlay="false" position="bottom" v-model="show">
      <p class="Copies flex-between">
        <span class="bold">{{$t('300304')}}</span>
        <!-- 选择购买份数 -->
        <i @click="show = false" class="iconfont icon-guanbi1"></i>
      </p>
      <p
        class="price"
        v-html="$t('300305',{minPrice:shopMessage.minPrice,currency:shopMessage.currency.toUpperCase(),maxBuyCount:shopMessage.maxBuyCount})"
      ></p>
      <div class="inputBox">
        <span @click="subtractNum" class="subtract bold inline-block" :class="{disable:num<=1}">—</span>
        <div class="input">
          <p>
            <input @input="handleInput" maxlength="4" v-model="num" type="text" />
            {{$t('300306')}}
          </p>
          <p>{{$t('300318',{num:numMultiply(shopMessage.minPrice,num),currency:shopMessage.currency.toUpperCase()})}}</p>
        </div>
        <span @click="addNum" class="add bold inline-block">+</span>
      </div>
      <div class="prizeDescribe">
        <!-- 购买份数越多购买成功概率越大 -->
        <p>{{$t('300307',{num:assetsNum,currency:shopMessage.currency.toUpperCase()})}}</p>
      </div>
      <div class="buy">
        <van-button
          @click.stop="buyShop(shopMessage.id)"
          :disabled="num==''||num==0"
          class="bold"
          type="default"
        >{{$t('300308')}}</van-button>
        <!-- 购买 -->
      </div>
    </van-popup>
    <van-popup class="tipModel" :close-on-click-overlay="false" v-model="tipModel">
      <p class="p">
        <svg>
          <use xlink:href="#icon-tishi-1" />
        </svg>
      </p>
      <p class="describe bold inline-block">{{tipMessage}}</p>
      <div class="btn inline-block">
        <!-- 错失良机 -->

        <van-button @click="tipModel=false">{{$t('300309')}}</van-button>
        <van-button @click="rechargeBalance">{{$t('300297')}}</van-button>
        <!-- 余额充值 -->
      </div>
    </van-popup>
    <!-- <van-popup :show="show" :content="content" :colseFun="closePopup"></van-popup> -->
    <tips-model :show="tipsdialog" :content="tipMessage" :colseFun="closeTips"></tips-model>
    <van-popup class="tipModel" :close-on-click-overlay="false" v-model="selled">
      <p class="p">
        <svg>
          <use xlink:href="#icon-tishi-1" />
        </svg>
      </p>
      <p class="describe bold inline-block">{{tipMessage}}</p>
      <div class="sell inline-block">
        <!-- 再试一次 -->
        <van-button @click="()=>{selled=false;$router.go(-1)}">{{$t('300312')}}</van-button>
      </div>
    </van-popup>
    <van-popup class="tipModel" :close-on-click-overlay="false" v-model="rechargeModel">
      <p class="p">
        <svg>
          <use xlink:href="#icon-tishi-1" />
        </svg>
      </p>
      <p class="recharge inline-block">{{$t('300313')}}</p>
      <!-- 请在APP上执行充值或者P2P入金操作 -->
      <div class="sell inline-block">
        <van-button @click="rechargeModel=false">{{$t('300286')}}</van-button>
      </div>
    </van-popup>
     <div class='purchase-toast' v-if='buySuccess'>
        <lottie class='lottie' :options='shopMessage.status==1&&num==1?defaultOptions:towOptions'></lottie>
        <p class='bold'>{{tipMessage}}</p>
      </div>
      <van-popup class="prizeModel" :close-on-click-overlay="false" v-model="prizeModel">
      <p class="p">
        <!-- 恭喜您 -->
        <img
          class="mirrorRotateLevel"
          src="../../../static/images/congratulations.png"
          alt
        />
        {{$t('300310')}}

        <img src="../../../static/images/congratulations.png" alt />
      </p>
      <p class="shopName bold">{{prizeMessage.snapshotTitle}}</p>
      <p class="prizeImage">
        <img src="../../../static/images/Issued.png" alt />
      </p>
      <div class="btn inline-block" v-if='$route.query.isApp==1'>
        <van-button class="bold" @click='showOff'>{{$t('300346')}}</van-button>
        <!-- 炫耀一下 -->
      </div>
      <van-button v-if='$route.query.isApp==1' class="bold checkGift" @click="()=>{ViewedTakeNotes();$router.push({path:'/prizeHistory',query:{name:5,isApp:$route.query.isApp}})}">{{$t('300351')}}</van-button>
       <div class="btn inline-block" v-if='$route.query.isApp!=1' @click="()=>{ViewedTakeNotes();$router.push({path:'/prizeHistory',query:{name:5,isApp:$route.query.isApp}})}">
        <van-button class="bold">{{$t('300351')}}</van-button>
        <!-- 炫耀一下 -->
      </div>
      <div class="close">
        <svg @click="closePrize">
          <use xlink:href="#icon-guanbi2" />
        </svg>
      </div>
    </van-popup>
  </div>
</template>
<script>
// import VanPopup from "./compontents/popup.vue"
import { Button, Swipe, SwipeItem, Popup, Toast } from 'vant'
import TipsModel from "./compontents/tipsModel.vue"
import { getShopDetail, getUserAssets, buyPrizeShop,
getHorseLamp,getBannerProduct,getDetailList,checkIssuedTakeNotes,
ViewedTakeNotes
 } from './api'
import { mapGetters } from 'vuex'
import Methods from '../../utils/methods'
import AliexSwiper from '../../compontents/swiper.vue'
import onceBuy from '../../../static/animationData/one.json'
import twiceBuy from '../../../static/animationData/more.json'
export default {
  components: {
    // VanPopup,
    VanButton: Button,
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
    VanPopup: Popup,
    TipsModel,
    AliexSwiper
  },
  data() {
    return {
      defaultOptions: { animationData: onceBuy,loop:false },
      towOptions:{ animationData:twiceBuy,loop:false},
      show: false,
      num: 1,
      selled: false,
      assetsNum: 0,
      shopMessage: {
        currency: '',
        imgs: []
      },
      tipModel: false,
      tipsdialog: false,
      tipMessage: '',
      horseLampData: [],
      cftj: false,
      timer: null,
      rechargeModel: false,
      prizeMsgList:[],
      buySuccess:false,
      prizeModel:false,
      isOpen:false,
      prizeMessage:{
      snapshotTitle:''
      }
    }
  },
  created() {
    if(this.$route.query.banner){
      this.getBannerProduct()
    }else{
      this.getShopDetail();
    }
    this.getHorseLamp();
   if(this.$route.query.token||this.token){
     this.checkTakeNotes()
   }
    window.document.documentElement.setAttribute(
      "dir",
      this.isDirection ? "rtl" : "ltr"
    );

  },
  computed: {
    ...mapGetters(['token', 'isApp', 'isDirection', 'language'])

  },
  methods: {
    checkTakeNotes(){
      checkIssuedTakeNotes().then(res=>{
      if(res.data){
         this.prizeMessage = res.data;
         this.prizeModel = true
      }
      })
    },
    ViewedTakeNotes(){
      ViewedTakeNotes({id:this.prizeMessage.id})
    },
      showOff(){
        this.ViewedTakeNotes()
        this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appShowOff,
        {
          code: 200,
          title: this.prizeMessage.share||'',
          url:window.location.origin+'/purchase',
          text: this.prizeMessage.highlighting||'',
          join:this.$t('300347')
        },
        data => {}
      );
    },
    closePrize() {//中奖弹框
      this.ViewedTakeNotes()
      this.prizeModel = false;
    },
    getBannerProduct(){
      getBannerProduct(this.$route.query.id).then(res=>{
        this.shopMessage = res.data
        this.getDetailList();
      })
    },
    getDetailList(){
      getDetailList({mallProductId:this.shopMessage.mallProductId}).then(res=>{
        this.prizeMsgList = res.data
      })
    },

    handleShare() {
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appSharing,
        {
          code: 200,
          img: this.shopMessage.imgs[0],
          title: this.$t('300333'),
          url: window.location.href.split('?')[0] + '?' + `id=${this.$route.query.id}`,
          text:''
        },
        data => { }
      );
    },
    getHorseLamp() {
      getHorseLamp({ type: 1 }).then(res => {
        this.horseLampData = res.data;
      })
    },
    numMultiply(arg1, arg2) {
      return Methods.numMultiply(Number(arg1), Number(arg2))
    },
    rechargeBalance() {
      this.tipModel = false;
      if (this.$route.query.isApp == 1) {
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appRecharge,
          {
            code: 200,
            active: window.location.origin + '/purchase'
          },
          data => {
          }
        );
      } else {
        this.rechargeModel = true
      }
    },
    buyShop(id) {
      if (this.cftj) return
      document.activeElement.blur();
      this.cftj = true
      this.isOpen = true
      this.show = false
      buyPrizeShop({ mallPrizeId: id, amount: this.num }).then(res => {
        // console.log(res,'fhdjhfjkdfh')
        if (res.code === 505) {
          this.tipModel = true;
          this.isOpen = false
        }
        else if (res.code === 502) {
          this.selled = true;
          this.isOpen = false
        }
        else if (res.code === 200) {
          this.buySuccess = true
          let timer = setTimeout(() => {
            // this.tipsdialog = true;
            this.buySuccess = false
            this.isOpen = false
            clearTimeout(timer)
          }, 2000)
            if(this.$route.query.banner){
            this.getBannerProduct()
           }else{
             this.getShopDetail();
            }
        } else {
          // Toast(res.msg)
        }
        // console.log(res.msg)
        this.tipMessage = res.msg
        this.cftj = false
      })
    },
    closeTips() {
      // console.log(123)
      this.tipsdialog = false
    },
    getShopDetail() {
      getShopDetail(this.$route.query.id).then(res => {
        this.shopMessage = res.data;
        this.getDetailList();
      })
    },
    subtractNum() {
      if (this.num <= 1) return
      this.num--;
    },
    addNum() {
      if (this.num > 9999) {
        this.num = 9999;
        return
      }
      this.num++;
    },
    handleInput() {
      this.num = this.num.replace(/^0(0+)|[^\d]+/g, '');
      //   console.log(this.num)
    },
    handler() {
      if(this.isOpen){return}
      if (this.$route.query.token || this.token) {
        // this.shopMessage = res.data
        getUserAssets({ currency: this.shopMessage.currency }).then(resp => {
          console.log(resp.data)
          this.assetsNum = resp.data
        })
        // this.getShopDetail()
        this.show = true
      } else {
        this.appLogin()
      }
    },
    appLogout() {
      var _this = this;
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appLogout,
        { code: 200 },
        data => {
          _this.isLogin = false;
          removeToken();
          removeCookie("userInfo");
          _this.appLogin();
        }
      );
    },
    appLogin() {
      // console.log(window.location)
      if (this.$route.query.isApp == 1) {
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appLogin,
          {
            code: 200, type: "login",
            url: window.location.origin + '/purchase'
          },
          data => { }
        );
      } else {
        this.$router.push({ path: '/login', query: { historyBack: '/purchase' } });
      }
    }
  },
  mounted() {
    // this.handler()
    this.timer = setInterval(() => {
      this.getHorseLamp()
      this.getDetailList()
    }, 30000)
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
<style lang='scss' scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
[dir="ltr"] .productdeta-details {
     .app-down{
      img{
        margin-right: torem(8);
      }
    }
  .inputBox {
    .subtract {
      border-right: torem(1) solid rgba(188, 188, 188, 1);
    }
    .add {
      border-left: torem(1) solid rgba(188, 188, 188, 1);
    }
  }
  .announced-swipe {
    img {
      margin-right: torem(4);
    }
  }
  .notice-bar {
    left: torem(10);
    img {
      margin-right: torem(4);
    }
  }
  .commodity {
    &-oncePrice {
      .currency {
        padding-right: torem(16);
        display: inline-block;
      }
    }
    &-progress-bar {
      .fireImage {
        margin-left: torem(-18);
      }
      .rate-of-progress {
        .progress-img {
          left: 0;
        }
        .progress-color {
          left: 0;
          background: linear-gradient(to right, #ff4141, #ffcc3f, #fffee1);
        }
      }
    }
  }
}
[dir="rtl"] .productdeta-details {
     .app-down{
      img{
        margin-left: torem(8);
      }
    }
  .inputBox {
    .subtract {
      border-left: torem(1) solid rgba(188, 188, 188, 1);
    }
    .add {
      border-right: torem(1) solid rgba(188, 188, 188, 1);
    }
  }
  // /deep/ .van-swipe-item{
  //   direction: rtl;
  //     img{
  //      margin-left: torem(4);
  //   }
  // }
  .announced-swipe {
    img {
      margin-left: torem(4);
    }
  }
  .notice-bar {
    right: torem(10);
    img {
      margin-left: torem(4);
    }
  }
  .commodity {
    &-oncePrice {
      .currency {
        padding-left: torem(16);
        display: inline-block;
      }
    }
    &-progress-bar {
      .fireImage {
        margin-right: torem(-18);
      }
      .rate-of-progress {
        .progress-img {
          // position: absolute;
          // width: 100%;
          // top: 0;
          right: 0;
          // animation: progress-move 4s linear infinite;
        }
        .progress-color {
          right: 0;
          background: linear-gradient(to left, #ff4141, #ffcc3f, #fffee1);
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
.productdeta-details {
  // height: 100%;

  .purchase-toast{
      padding: torem(8) 0 torem(42) 0;
      box-sizing: border-box;
      p{
        color: #fff;
        font-size: torem(16);
        line-height: torem(18);
        margin-top: torem(14);
        width: 100%;
        text-align: center;
      }
        >div{
        width: torem(60)!important;
        height: torem(60)!important;
        }
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 9999;
      transform: translate(-50%,-50%);
      width: torem(197);
      height: torem(143);
      border-radius: torem(8);
      background: rgba($color: #000000, $alpha: .8);
    }
   .app-down {
    padding: torem(10) torem(24);
    background-color: #fff6dc;

    .download-content {
      p {
        font-size: torem(15);
        color: #40475a;
        margin-bottom: torem(4);
        font-weight: bold;
      }

      span.block {
        font-size: torem(10);
        color: #40475a;
        line-height: torem(11);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
    }



   dl{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    dt{
      svg{
        width: torem(24);
        height: torem(24);
      }
    }
    dd{
   margin-top:torem(4) ;
   width: torem(48);
   text-align: center;
   color: #40475A;
   font-size: torem(10);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-top: torem(4);
    line-height: torem(12);
    }
   }
  }
  width: 100%;
  min-height: 100vh;
  background: #fff;
  overflow: hidden;
  //   overflow-y: auto;
  display: flex;
  flex-direction: column;
  .productdeta-header {
    background: #ffffff;
    height: torem(44);
    width: 100%;
    // position: fixed;
    // top: 0;
    // left: 0;
    // z-index: 99;
    padding: 0 torem(16);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      font-size: torem(18);
    }
    span {
      font-size: torem(12);
      color: #000922;
    }
  }
  .productdeta-main {
    flex: 1;
    overflow-y: auto;
    // margin-top: torem(44);
    background: #fff;
    padding: 0 torem(16) torem(82);
    .Product-introduction {
      text-align: center;
      // margin-top: torem(8);
      padding: torem(24) 0;
      background: #ffffff;
      font-size: torem(14);
      color: rgba(0, 9, 34, 1);
      > p {
        display: flex;
        justify-content: center;
        height: torem(17);
        align-items: center;
        margin-bottom: torem(10);
        font-size: torem(16);
        svg {
          width: torem(17);
          height: torem(12);
          margin: 0 torem(8);
        }
      }
      div {
        line-height: torem(21);
        color: #000922;
        font-size: torem(14);
        text-align: start;
      }
    }
  }
  .productdeta-foot {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: torem(82);
    padding: torem(16) torem(16);
    box-sizing: border-box;
    border-top: torem(1) solid rgba(239, 239, 239, 1);
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    > div {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      dl {
        width: torem(53);
        height: torem(38);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        dt {
          i {
            font-size: torem(20);
          }
        }
        dd {
           width: 100%;
           text-align: center;
           font-size: torem(10);
           text-overflow: ellipsis;
           line-height: torem(12);
           justify-content: center;
           overflow: hidden;
           white-space: nowrap;
           color: #000922;

        }
      }
      /deep/ .van-button {
        width: torem(280);
      }
    }

    /deep/ .van-button {
      width: torem(311);
      height: torem(50);
      background: #ffc72b;
      font-size: torem(16);
      border-radius: torem(4);
      //   margin: 0 auto;
    }
    //继续参与的按钮
    .alignBtn {
      background: #f34e74;
      color: #ffffff;
    }
  }
}
.tipModel {
  // /deep/ .van-popup {
  width: torem(312);
  min-height: torem(196);
  border-radius: torem(8);
  padding: torem(24);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  // }
  .p {
    text-align: center;
    svg {
      width: torem(48);
      height: torem(48);
    }
  }
  .describe {
    font-size: torem(16);
    // margin: 0 torem(16);
    text-align: center;
    height: torem(24);
    line-height: torem(24);
    width: 100%;
    margin: torem(16) 0 torem(24);
  }
  .recharge {
    font-size: torem(14);
    width: 100%;
    line-height: torem(21);
    height: torem(21);
    margin: torem(16) 0 torem(24);
    text-align: center;
  }
  .sell {
    /deep/ .van-button {
      width: torem(264);
      height: torem(44);
      background: #ffc72b;
      border-radius: torem(4);
      font-size: torem(16);
      color: #000922;
    }
  }
  .btn {
    display: flex;
    justify-content: space-between;
    width: 100%;
    /deep/ .van-button {
      width: torem(128);
      height: torem(44);
      padding: 0;
      border-radius: torem(4);
      background: rgba(234, 236, 239, 1);
      font-size: torem(16);
      &:nth-child(2) {
        background: rgba(255, 199, 43, 1);
      }
    }
  }
}
.form-popup {
  //   .van-popup {
  min-height: torem(336);
  border-radius: torem(16) torem(16) 0 0;
  padding: torem(24) torem(16) torem(16);
  box-sizing: border-box;
  //   }
  .buy {
    // width: fit-content;
    // margin: 0 auto;
    text-align: center;
  }
  /deep/ .van-button {
    width: torem(311);
    height: torem(50);
    background: #ffc72b;
    font-size: torem(16);
    border-radius: torem(4);
    //   margin: 0 auto;
  }

  .Copies {
    span {
      font-size: torem(16);
    }
    i {
      font-size: torem(12);
    }
  }
  .price {
    display: inline-block;
    font-size: torem(14);
    width: torem(311);
    color: rgba(127, 132, 144, 1);
    margin: torem(24) 0;
    text-align: center;
    line-height: torem(16);
    span {
      color: #fa4d56;
    }
  }
  .inputBox {
    width: torem(280);
    height: torem(64);
    box-sizing: border-box;
    display: flex;
    margin: 0 auto;
    border: torem(1) solid rgba(188, 188, 188, 1);
    border-radius: torem(4);
    .disable{
      color: #bcbcbc;
    }
    span {
      font-size: torem(24);
      width: torem(50);
      line-height: torem(64);
      // height: torem(64);
      vertical-align: middle;
      text-align: center;
    }

    .input {
      width: torem(180);
      padding: torem(10) 0;
      box-sizing: border-box;
      p {
        text-align: center;
        color: rgba(0, 9, 34, 1);
        font-size: torem(12);
        &:nth-child(1) {
          input {
            width: torem(70);
            font-size: torem(24);
            font-weight: 500;
            text-align: center;
          }
        }
        &:nth-child(2) {
          margin-top: torem(4);
          color: rgba(127, 132, 144, 1);
          font-size: torem(12);
        }
      }
    }
  }
}
.prizeDescribe {
  min-height: torem(40);
  width: torem(268);
  background: rgba(255, 199, 43, 0.2);
  border-radius: torem(20);
  padding: torem(6) torem(16);
  margin: torem(24) auto;
  font-size: torem(12);
  p {
    line-height: torem(14);
    color: #000922;
    text-align: center;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  //   vertical-align: middle;
}

/deep/ .van-swipe__indicator {
  width: torem(5);
  height: torem(5);
  background: rgba(188, 188, 188, 1);
}
/deep/ .van-swipe__indicator--active {
  background: #ffc72b;
}

.commodity {
  padding-top: torem(16) ;
  background: #ffffff;
  // border-radius: torem(16) torem(16) 0 0;
  margin-top: torem(8);
  .announced-in-the-past {
    display: flex;
    align-items: center;
    width: torem(343);
    height: torem(48);
    background: #f6f8fa;
    margin-top: torem(12);
    border-radius: torem(4);
    justify-content: space-between;
    padding: 0 torem(12);
    span {
      display: inline-block;
      width: torem(82);
      font-size: torem(14);
      height: torem(17);
      line-height: torem(18);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #7f8490;
    }
    .announced {
      width: torem(162);
      background: #f34e74;
      border-radius: torem(17);
      color: #fff;
      .announced-swipe {
        padding: 0 torem(12);
        .van-swipe-item {
          display: flex;
          width: torem(138);
          align-items: center;
          height: torem(24);
          line-height: torem(24);
          img {
            width: torem(14);
            height: torem(14);
          }
          p {
            line-height: torem(24);
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: torem(12);
            white-space: nowrap;
          }
        }
      }
    }
    i {
      font-size: torem(12);
      color: #7f8490;
    }
  }
  .Purchase-process {
    min-height: torem(135);
    position: relative;
    margin-top: torem(16);
    .process-top {
      height: torem(8);
      background: rgba(239, 239, 239, 1);
      position: absolute;
      width: 100vw;
      top: 0;
      left: torem(-16);
    }
    .process-bottom {
      height: torem(8);
      background: rgba(239, 239, 239, 1);
      position: absolute;
      bottom: 0;
      left: torem(-16);
      width: 100vw;
    }
    .process-content {
      padding: torem(24) torem(16);
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      > p {
        display: flex;
        justify-content: center;
        height: torem(17);
        align-items: center;
        margin-bottom: torem(10);
        font-size: torem(16);
        svg {
          width: torem(17);
          height: torem(12);
          margin: 0 torem(8);
        }
      }
      .flowPath {
        margin-top: torem(17);
        display: flex;
        // justify-content: space-between;
        // align-items: start;
        dl {
          width: torem(72);
          dt {
            text-align: center;
            svg {
              margin: 0 auto;
              width: torem(26);
              height: torem(26);
            }
          }
          dd {
            margin-top: torem(4);
            max-width: torem(72);
            font-size: torem(12);
            color: #40475a;
            line-height: torem(14);
            text-align: center;
          }
        }
        p {
          margin: 0 torem(4);
          svg {
            width: torem(58);
            height: torem(26);
          }
        }
      }
    }
  }
  .Period {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: torem(24);
    margin-bottom: torem(24);
    span {
      display: inline-block;
      color: rgba(127, 132, 144, 1);
      font-size: torem(12);
      &:last-child {
        height: 100%;
        padding: 0 torem(10);
        border: torem(1) solid rgba(127, 132, 144, 1);
        line-height: torem(24);
        border-radius: torem(12);
      }
    }
  }
  &-item {
    width: torem(311);
    height: torem(156);
    background: #ccc;
    text-align: center;
    vertical-align: middle;
  }
  &-name {
    font-size: torem(16);
    color: #000922;
    // margin-top: torem(16);
    margin-bottom: torem(9);
    line-height: torem(18);
  }
  &-oncePrice {
    color: #7f8490;
    font-size: torem(12);
    margin-bottom: torem(14);
    line-height: torem(20);
    em {
      font-style: normal;
      font-size: torem(16);
      color: rgba(243, 78, 116, 1);
      line-height: torem(20);
    }
    .oldPrice {
      font-size: torem(12);
      text-decoration: line-through;
      // margin: 0 torem(12);
      line-height: torem(20);
    }
    .currency {
      font-size: torem(12);
      color: rgba(243, 78, 116, 1);
      line-height: torem(20);
    }
  }
  &-progress-bar {
    width: torem(339);
    margin: 0 auto;
    height: torem(12);
    border-radius: torem(6);
    background: #f3f1ee;
    margin-bottom: torem(10);
    position: relative;
    display: flex;
    align-items: center;
    .fireImage {
      width: torem(45);
      height: torem(27);
    }
    .rate-of-progress {
      height: torem(12);
      width: 0;
      transition: width 3s linear;
      .progress-img {
        position: absolute;
        height: torem(12);
        // width: 100%;
        top: 0;
        // left: 0;
        opacity: 0.5;
        width: 0;
        transition: width 3s linear;
        background: url("../../assets/images/mask.png") repeat-x 50%;
        border-radius: torem(6);
        animation: progress-move 4s linear infinite;
      }
      .progress-color {
        height: torem(12);
        width: 100%;
        top: 0;
        border-radius: torem(6);
      }
    }
  }
  &-sellNum {
    color: #7f8490;
    font-size: torem(12);
    line-height: torem(14);
  }
}
@keyframes progress-move {
  0% {
    background-position: torem(-60) 0;
  }
}

.van-button {
  border: none;
}
.swiper-banner {
  position: relative;

  width: torem(342);
  overflow: hidden;
  height: torem(342);
  border-radius: torem(8);
  > .van-swipe {
    width: torem(342);
    height: torem(342);
    border-radius: torem(8);
    direction: ltr;
    .van-swipe-item {
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: torem(8);
      }
    }
  }
}
.announced-in-the-past {
  .announced-swipe {
    height: torem(24);
    line-height: torem(24);
  }
}
.notice-bar {
  position: absolute;
  top: torem(16);
  z-index: 9;
  padding: 0 torem(16);
  width: auto;
  line-height: torem(30);
  background: rgba(0, 0, 0, 0.7);
  border-radius: torem(18);
  color: #fff;
  overflow: hidden;
  font-size: torem(14);
  /deep/ .van-swipe-item {
    display: flex;
    width: torem(240);
    align-items: center;
    p {
      max-width: torem(240);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .notice-swipe {
    height: torem(30);
    line-height: torem(30);
  }
  img {
    width: torem(14);
    height: torem(14);
  }
}
.prizeModel {
  background: transparent;
  .checkGift{
    background: transparent;
    color: #fff;
    font-size: torem(16);
    line-height: torem(16);
    margin: torem(20) auto 0;
    display: block;
  }
  .close {
    text-align: center;
    svg {
      width: torem(28);
      height: torem(28);
      margin: 0 auto;
      // text-align: center;
      margin-top: torem(21);
    }
  }

  .p {
    text-align: center;
    img {
      width: torem(14);
      height: torem(14);
      margin: 0 torem(8);
    }
    font-size: torem(14);
    background: linear-gradient(to right, #d3f6ff, #fffbc9);
    -webkit-background-clip: text;
    color: transparent;
  }
  .shopName {
    font-size: torem(20);
    line-height: torem(23.44);
    background: linear-gradient(to right, #d3f6ff, #fffbc9);
    -webkit-background-clip: text;
    color: transparent;
    text-align: center;
    margin-top: torem(4);
    margin-bottom: torem(24);
  }
  .prizeImage {
    width: torem(278);
    height: torem(211.75);
    img {
      width: torem(278);
      height: torem(211.75);
    }
  }
  .btn {
    // text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: torem(48);
    min-height: torem(50);
    >span{
      display: inline-block;
      margin-top: torem(20);
      line-height: torem(16);
      font-size: torem(16);
      color: #fff;
    }
    flex-shrink: 0;
    .van-button {
      width: torem(257);
      height: torem(50);
      // height: 100%;
      font-size: torem(16);
      // line-height: torem(50);
      color: #000922;
      // background: transparent;
      border: none;
      background: url("../../../static/images/btnbackground.png") no-repeat;
      background-size: 100% 100%;
      border-radius: torem(4);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/purchase/Productdetails.vue